package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.Serializable

@Serializable
data class VerifyTokenRequest(
    val token: String
)
